import { render, staticRenderFns } from "./ApplicantProfileDeactivatedBadge.vue?vue&type=template&id=71458796"
import script from "./ApplicantProfileDeactivatedBadge.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileDeactivatedBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports